// src/components/StateSelector/StateSelector.jsx
import React from "react";
import "./StateSelector.css";

export default function StateSelector({ states, selectedState, onSelect }) {
  return (
    <div className="state-selector">
      {/* <label htmlFor="state-dropdown">Estado:</label> */}
      <select
        id="state-dropdown"
        value={selectedState}
        onChange={(e) => onSelect(e.target.value)}
      >
        <option value="">Selecciona un Estado </option>
        {states.map((st) => (
          <option key={st} value={st}>
            {st}
          </option>
        ))}
      </select>
    </div>
  );
}
